/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Topics_FoundInputs */

const en_no_topics_found = /** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No discussion topics found.`)
};

const es_no_topics_found = /** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron temas de discusión.`)
};

const fr_no_topics_found = /** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun sujet de discussion trouvé.`)
};

const de_no_topics_found = /** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Diskussionsthemen gefunden.`)
};

const id_no_topics_found = /** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada topik diskusi yang ditemukan.`)
};

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const ja_no_topics_found = en_no_topics_found;

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const zh_no_topics_found = en_no_topics_found;

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const ar_no_topics_found = en_no_topics_found;

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const it_no_topics_found = en_no_topics_found;

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const ru_no_topics_found = en_no_topics_found;

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const pt_no_topics_found = en_no_topics_found;

/** @type {(inputs: No_Topics_FoundInputs) => LocalizedString} */
const ko_no_topics_found = en_no_topics_found;

/**
* | output |
* | --- |
* | "No discussion topics found." |
*
* @param {No_Topics_FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_topics_found = /** @type {((inputs?: No_Topics_FoundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Topics_FoundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_topics_found(inputs)
	if (locale === "es") return es_no_topics_found(inputs)
	if (locale === "fr") return fr_no_topics_found(inputs)
	if (locale === "de") return de_no_topics_found(inputs)
	if (locale === "ja") return ja_no_topics_found(inputs)
	if (locale === "zh") return zh_no_topics_found(inputs)
	if (locale === "ar") return ar_no_topics_found(inputs)
	if (locale === "id") return id_no_topics_found(inputs)
	if (locale === "it") return it_no_topics_found(inputs)
	if (locale === "ru") return ru_no_topics_found(inputs)
	if (locale === "pt") return pt_no_topics_found(inputs)
	return ko_no_topics_found(inputs)
});